import createIcon from '../../createIcon';

/**
 * @component @name FileCopy
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAxSDQuNUMzLjQgMSAyLjUgMS45IDIuNSAzVjE3SDQuNVYzSDE2LjVWMVpNMTUuNSA1TDIxLjUgMTFWMjFDMjEuNSAyMi4xIDIwLjYgMjMgMTkuNSAyM0g4LjQ5QzcuMzkgMjMgNi41IDIyLjEgNi41IDIxTDYuNTEgN0M2LjUxIDUuOSA3LjQgNSA4LjUgNUgxNS41Wk0xNC41IDEySDIwTDE0LjUgNi41VjEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FileCopy = createIcon('FileCopy', [
  [
    'path',
    {
      d: 'M16.5 1H4.5C3.4 1 2.5 1.9 2.5 3V17H4.5V3H16.5V1ZM15.5 5L21.5 11V21C21.5 22.1 20.6 23 19.5 23H8.49C7.39 23 6.5 22.1 6.5 21L6.51 7C6.51 5.9 7.4 5 8.5 5H15.5ZM14.5 12H20L14.5 6.5V12Z',
      key: 'wtbfao',
    },
  ],
]);

export default FileCopy;
